const styles = (theme) => ({
  card: {
    borderRadius: theme.spacing(10),
    padding: theme.spacing(8),
    backgroundColor: theme.palette.background.paper,
  },
})

export default styles
